import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';


if (environment.production) {
    enableProdMode();
}

/**
 * Sentry init in production mode
 */
if ((window as any).appSettings.APP_SETTINGS_SENTRY_DNS_URL && environment.production) {
    Sentry.init({
        dsn: (window as any).appSettings.APP_SETTINGS_SENTRY_DNS_URL,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((error: unknown) => console.error(error));
